import { Injectable } from '@angular/core';
import { ApiHttp } from '@core/http/api.http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { isNil } from 'lodash';
import { AccountReadModel } from '@shared/models/account-read.model';
import Helper from '@core/helper/common.helper';

@Injectable()
export class AccountReadService {

    constructor(private http: ApiHttp) {

    }

    getAccounts(params: any): Observable<AccountReadModel[]> {
        return this.http.get(`/account`, Helper.parseParams({...params}))
            .pipe(
                filter((res: any) => {
                    return !isNil(res) && !isNil(res.data);
                }),
                map((res: any) => res.data)
            );
    }

    getAccount(id: string): Observable<AccountReadModel> {
        return this.http.get('/account/' + id)
            .pipe(map((res: any) => res.data));
    }
}
